import { fork } from 'redux-saga/effects'

import { aiDocumentReviewConfigSaga } from './aiDocumentReviewConfig'
import { collectStepReferenceSaga } from './collectStepReference'
import { customerSaga } from './customer'
import { customerProductSaga } from './customerProduct'
import { documentReviewSaga } from './documentReview'
import { docusignTemplateSaga } from './docusignTemplate'
import { gigsafeConfigSaga } from './gigsafeConfig'
import { gigsafeUserSaga } from './gigsafeUser'
import { insurancePolicySaga } from './insurancePolicy'
import { insuranceProductSaga } from './insuranceProduct'
import { internalAuthSaga } from './internalAuth'
import { invoiceSaga } from './invoice'
import { lmsTrainingSaga } from './lmsTraining'
import { marketSaga } from './market'
import { mcDocumentReviewSaga } from './mcDocumentReview'
import { oatfiBusinessSaga } from './oatfiBusiness'
import { oauthClientSaga } from './oauthClient'
import { onboardingFlowEditorSaga } from './onboardingFlowEditor'
import { onboardingTemplateListSaga } from './onboardingTemplateList'
import { partnerDriverSaga } from './partnerDriver'
import { paymentConfigSaga } from './paymentConfig'
import { paymentsReviewSaga } from './paymentsReview'
import { bankOnboardingSaga } from './bankOnboarding'
import { reconciliationSaga } from './reconciliation'
import { feeWithdrawalsSaga } from './feeWithdrawals'
import { refundSaga } from './refund'
import { remoteConfigSaga } from './remoteConfig'
import { retryConfigSaga } from './retryConfig'
import { internalAccessSaga } from './internalAccess'
import { retryConfigTemplateSaga } from './retryConfigTemplate'
import { templatePreviewSaga } from './templatePreview'
import { transactionsReviewSaga } from './transactionsReview'
import { usBankKillswitchSaga } from './usBankKillswitch'
import { usBankTransactionsSaga } from './usBankTransactions'
import { walletSaga } from './wallet'
import { webhookSaga } from './webhook'

export function* rootSaga() {
  yield fork(aiDocumentReviewConfigSaga)
  yield fork(internalAuthSaga)
  yield fork(collectStepReferenceSaga)
  yield fork(customerSaga)
  yield fork(customerProductSaga)
  yield fork(documentReviewSaga)
  yield fork(docusignTemplateSaga)
  yield fork(gigsafeConfigSaga)
  yield fork(gigsafeUserSaga)
  yield fork(insurancePolicySaga)
  yield fork(insuranceProductSaga)
  yield fork(invoiceSaga)
  yield fork(lmsTrainingSaga)
  yield fork(marketSaga)
  yield fork(mcDocumentReviewSaga)
  yield fork(oatfiBusinessSaga)
  yield fork(oauthClientSaga)
  yield fork(onboardingFlowEditorSaga)
  yield fork(onboardingTemplateListSaga)
  yield fork(partnerDriverSaga)
  yield fork(paymentConfigSaga)
  yield fork(paymentsReviewSaga)
  yield fork(bankOnboardingSaga)
  yield fork(reconciliationSaga)
  yield fork(feeWithdrawalsSaga)
  yield fork(refundSaga)
  yield fork(remoteConfigSaga)
  yield fork(retryConfigSaga)
  yield fork(retryConfigTemplateSaga)
  yield fork(internalAccessSaga)
  yield fork(templatePreviewSaga)
  yield fork(transactionsReviewSaga)
  yield fork(usBankKillswitchSaga)
  yield fork(usBankTransactionsSaga)
  yield fork(walletSaga)
  yield fork(webhookSaga)
}
